export default __webpack_public_path__ + "static/gn-87f1c4556e1be59c18fb3d6751689f69.svg";